function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Alert, Select, Tag, InputNumber, Divider, notification, List, Drawer, Space, Modal } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import { BoxFill, CheckCircleFill } from "react-bootstrap-icons";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import PaymentReceipt from "../PaymentReceipt";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var AddCustomerOrder = function AddCustomerOrder(_ref) {
  var handler = _ref.handler,
    company = _ref.company;
  var ref = useRef();
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    deptOptions = _useState8[0],
    setDeptOptions = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    loadError = _useState10[0],
    setLoadError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataChanged = _useState12[0],
    setIsDataChanged = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    itemOptions = _useState14[0],
    setItemOptions = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    items = _useState16[0],
    setItems = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedItems = _useState18[0],
    setSelectedItems = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    totalCash = _useState20[0],
    setTotalCash = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    billComment = _useState22[0],
    setBillComment = _useState22[1];
  var _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    paidAmount = _useState24[0],
    setPaidAmount = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showReceipt = _useState26[0],
    setShowReceipt = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    invoiceDetails = _useState28[0],
    setInvoiceDetails = _useState28[1];
  var onFinish = function onFinish(values) {
    values.items.forEach(function (item_id) {
      if (selectedItems.filter(function (i) {
        return i.id == item_id;
      }).length > 0) {
        var item = items.filter(function (i) {
          return i.id == item_id;
        })[0];
        var extElementQuant = selectedItems.filter(function (i) {
          return i.id == item.id;
        })[0].quantity;
        setSelectedItems(selectedItems.filter(function (i) {
          return i.id != item.id;
        }));
        setSelectedItems(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            id: item.id,
            label: item.label,
            quantity: extElementQuant + 1,
            price: item.base_price
          }]);
        });
        setTotalCash(function (prev) {
          return prev + item.base_price * values.quantity;
        });
      } else {
        var _item = items.filter(function (i) {
          return i.id == item_id;
        })[0];
        setSelectedItems(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            id: _item.id,
            label: _item.label,
            quantity: values.quantity,
            price: _item.base_price
          }]);
        });
        setTotalCash(function (prev) {
          return prev + _item.base_price * values.quantity;
        });
      }
    });
  };
  var handleCommentChange = function handleCommentChange(v) {
    setBillComment(v.target.value);
  };
  var handleRc = function handleRc(v) {
    setPaidAmount(v);
  };
  var createInvoice = function createInvoice() {
    setIsFormLoading(true);
    var itemsArg = new Array();
    var itemsQuantityArg = new Array();
    var itemsLabelArg = new Array();
    var itemsPriceArg = new Array();
    selectedItems.forEach(function (i) {
      itemsArg.push(i.id);
      itemsQuantityArg.push(i.quantity);
      itemsLabelArg.push(i.label);
      itemsPriceArg.push(i.price);
    });
    axios.post(Common.baseApiUrl + "createinvoice", {
      user_id: Common.currentUser.id,
      gas_station_id: company.gas_station_id,
      comment: billComment,
      items: itemsArg,
      quantities: itemsQuantityArg,
      labels: itemsLabelArg,
      prices: itemsPriceArg,
      company_id: company.id,
      total_amount: totalCash,
      paid_amount: paidAmount
    }).then(function (response) {
      if (response.data.status == 200) {
        if (paidAmount > 0) {
          setInvoiceDetails(response.data.invoice);
          setShowReceipt(true);
        } else {
          handler();
        }
      } else {
        notification.error({
          message: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var handleClearItem = function handleClearItem(item) {
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setTotalCash(function (prev) {
        return prev - item.price * extElementQuant;
      });
      //setSelectedItems(prev => [...prev, {id: item.id, label: item.label, quantity: extElementQuant + 1, base_price: item.base_price}]); 
    }
  };

  useEffect(function () {
    setIsDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'getproducts/' + Common.currentStation.id + "/" + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status == 200) {
        setItemOptions([]);
        setItems([]);
        response[0].data.products.forEach(function (i) {
          setItemOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: i.id,
              label: i.label
            }]);
          });
        });
        setItems(response[0].data.products);
      }
    })["catch"](function (error) {
      setLoadError('Une erreur est survenue');
    })["finally"](function () {});
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), loadError.length > 0 && /*#__PURE__*/_jsx("div", {
      style: {
        padding: "10px 0px 10px 0px"
      },
      children: /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: loadError,
        showIcon: true
      })
    }), /*#__PURE__*/_jsx(Form, {
      layout: "vertical",
      form: form,
      onFinish: onFinish,
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "items",
              label: "Produit | Service",
              children: /*#__PURE__*/_jsx(Select, {
                mode: "multiple",
                placeholder: "Choisir une element",
                options: itemOptions,
                rules: [{
                  required: true,
                  message: 'Ce champs est obligatoire'
                }]
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 2,
            md: 2,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "quantity",
              label: "Qte",
              rules: [{
                required: true,
                message: "Ce champ est obligatoire"
              }],
              children: /*#__PURE__*/_jsx(InputNumber, {
                style: {
                  width: '90px'
                },
                formatter: function formatter(value) {
                  return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                }
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: " ",
              children: /*#__PURE__*/_jsx(Button, {
                htmlType: "submit",
                disabled: items.length == 0,
                loading: isFormLoading,
                type: "default",
                children: /*#__PURE__*/_jsx("b", {
                  children: "Ajouter"
                })
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("h5", {
      children: [/*#__PURE__*/_jsx("b", {
        children: "CLIENT: "
      }), company.label]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        minHeight: "400px",
        padding: "10px"
      },
      children: [/*#__PURE__*/_jsx(List, {
        dataSource: selectedItems,
        itemLayout: "horizontal",
        renderItem: function renderItem(item, index) {
          return /*#__PURE__*/_jsx(List.Item, {
            actions: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                handleClearItem(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "RETIRER"
              })
            })],
            children: /*#__PURE__*/_jsx(List.Item.Meta, {
              avatar: /*#__PURE__*/_jsx(BoxFill, {
                size: 16
              }),
              title: item.label,
              description: /*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Prix : "
                  }), item.price.toLocaleString("Fr")]
                }), /*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Qte : "
                  }), item.quantity]
                })]
              })
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "TOTAL: "
        }), totalCash.toLocaleString("Fr")]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(InputNumber, {
            size: "large",
            defaultValue: "0",
            prefix: "Montant re\xE7u",
            onChange: handleRc,
            addonAfter: "GNF",
            style: {
              width: '240px'
            },
            formatter: function formatter(value) {
              return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            }
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 8,
          children: /*#__PURE__*/_jsx(TextArea, {
            size: "large",
            autoSize: true,
            onChange: handleCommentChange,
            placeholder: "Commentaire... Exemple: Modalit\xE9 de paiement"
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
    }), ContextHolder, /*#__PURE__*/_jsx(Button, {
      type: "primary",
      disabled: selectedItems.length == 0,
      loading: isFormLoading,
      onClick: function onClick() {
        confirm({
          title: /*#__PURE__*/_jsx("b", {
            children: "Confirmez-vous les informations?"
          }),
          content: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx("b", {
                children: "Montant Total: "
              }), " ", totalCash.toLocaleString("Fr")]
            }), /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx("b", {
                children: "Montant pay\xE9 : "
              }), " ", paidAmount.toLocaleString("Fr")]
            }), /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx("b", {
                children: "Reste \xE0 payer : "
              }), " ", (totalCash - paidAmount).toLocaleString("Fr")]
            })]
          }),
          onOk: function onOk() {
            createInvoice();
          }
        });
      },
      children: isFormLoading ? /*#__PURE__*/_jsx("b", {
        children: "CREATION DU DEVIS EN COURS"
      }) : /*#__PURE__*/_jsx("b", {
        children: "CREER LE DEVIS"
      })
    }), invoiceDetails && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(CheckCircleFill, {
            size: 30
          }), " RECU"]
        }),
        width: "280px",
        open: showReceipt,
        onClose: function onClose() {
          setShowReceipt(false);
          handler();
        },
        destroyOnClose: true,
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: /*#__PURE__*/_jsx("div", {
          ref: ref,
          style: {
            textAlign: 'center'
          },
          children: /*#__PURE__*/_jsx(PaymentReceipt, {
            transaction: invoiceDetails,
            company: company
          })
        })
      })
    })]
  });
};
export default AddCustomerOrder;